export const CONTACT_EMAILS = {
    default: "info@fisp.org.ar",
    educativo: "fispeducativo@fisp.org.ar",
    servicios: "marketing@fisp.org.ar",
};

export function getPageContactEmail(pathname = "") {
    if (pathname.startsWith("/educativo") || pathname.startsWith("/curso") || pathname.startsWith("/inscripcion")) {
        return CONTACT_EMAILS.educativo;
    }

    if (pathname.startsWith("/servicios")) {
        return CONTACT_EMAILS.servicios;
    }

    return CONTACT_EMAILS.default;
}

export function toMailto(email) {
    return `mailto:${email}`;
}
